import { Component, NgZone } from '@angular/core'
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular'
import 'firebase/auth';
import { ScreenOrientation } from '@ionic-native/screen-orientation'
import { MainPage } from '../main/main'
import { TranslateService } from '@ngx-translate/core'
import { Storage } from '@ionic/storage'
import { TutorialPage } from '../tutorial/tutorial'

@IonicPage()
@Component({
  selector: 'page-loading',
  templateUrl: 'loading.html',
})
export class LoadingPage {

  constructor(
    public navCtrl: NavController,
    public platform: Platform,
    public zone: NgZone,
    public translate: TranslateService,
    public screenOrientation: ScreenOrientation,
    public navParams: NavParams,
    private storage: Storage) {

      var device_lang = navigator.language.split('-')[0]
      if (device_lang == 'es') this.translate.setDefaultLang('es')
      else if (device_lang == 'en') this.translate.setDefaultLang('en')
      else if (device_lang == 'de') this.translate.setDefaultLang('de')
      else if (device_lang == 'fr') this.translate.setDefaultLang('fr')
      else this.translate.setDefaultLang('en')
      
  }

  ionViewWillEnter () {
    var that = this

    this.zone.run(async () => {
      let tutorialDone = await this.storage.get('welcomeTutorial')

      if(!tutorialDone){
        that.navCtrl.push(TutorialPage, {}, {animate: true, direction: 'forward', animation: 'wp-transition', duration: 500})
      } else { 
        that.navCtrl.push(MainPage, {}, {animate: true, direction: 'forward', animation: 'wp-transition', duration: 500})
      }

    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/loading/loading.ts